// extracted by mini-css-extract-plugin
export var card = "_lf-1";
export var summary = "_lf-0";